import { asideTabs, internetPackageEnum, LocalesType, RoadmapDataType } from "../constants/globals";
import { SIGNALING_STATUS } from "../constants/signaling";
import { ClientRoomReport } from "../proto/ClientRoomReport_pb";
import { ClientAction, GroupRoom, MplTransaction, Platform, RegisteredUser, Room, RoomMessageLog, RoomMessageType, RoomMessageWallet } from "../proto/Global_pb";
import { SignalingGetLogResponse } from "../proto/SignalingGetLog_pb";
import { SignalingOffer } from "../proto/SignalingOffer_pb";
import { ConnectionStatusType } from "../store/connection/types";
import { MessengerThemeLayoutType } from "../store/messenger/types";
import { internetPackageTypes } from "../components/popup/internet-packages/reducer";

const en = {
  recorder: {
    audio_permission_denied: "Lack of access to the microphone",
    video_permission_denied: "Lack of access to the camera",
  },
  call_status: {
    [SignalingGetLogResponse.SignalingLog.Status.MISSED]: "Missed",
    [SignalingGetLogResponse.SignalingLog.Status.CANCELED]: "Canceled",
    [SignalingGetLogResponse.SignalingLog.Status.INCOMING]: "Incoming",
    [SignalingGetLogResponse.SignalingLog.Status.OUTGOING]: "Outgoing",
  },
  connection: {
    [ConnectionStatusType.DISCONNECTED]: "Connecting",
    [ConnectionStatusType.CONNECTED]: "Securing",
    [ConnectionStatusType.SECURED]: "Authenticating",
    [ConnectionStatusType.LOGGED_IN]: "",
  },
  chats: {
    is_typing: "isTyping...",
    action: {
      [ClientAction.TYPING]: "is Typing...",
      [ClientAction.SENDING_IMAGE]: "is Sending Image...",
      [ClientAction.SENDING_FILE]: "is Sending File...]",
    },
    participantsCount: "Members : {{count}}",
    edited: "Edited",
    clear_cache: "Clear cache",
    clear_history: "Clear history",
    delete_chat: "Delete Chat",
    draft: "Draft",
    left_room: "Left room",
    join: "Join",
    start: "Start",
    isAdmin: "Admin",
    role: {
      [GroupRoom.Role["ADMIN"]]: "admin",
      [GroupRoom.Role["MEMBER"]]: "member",
      [GroupRoom.Role["MODERATOR"]]: "moderator",
      [GroupRoom.Role["OWNER"]]: "owner",
    },
    lastSeen: {
      [RegisteredUser.Status.LONG_TIME_AGO]: "Long time ago",
      [RegisteredUser.Status.LAST_MONTH]: "1 month ago",
      [RegisteredUser.Status.LAST_WEEK]: "1 week ago",
      [RegisteredUser.Status.ONLINE]: "Online",
      [RegisteredUser.Status.EXACTLY]: "",
      [RegisteredUser.Status.RECENTLY]: "Recently",
      [RegisteredUser.Status.SUPPORT]: "Support",
      [RegisteredUser.Status.SERVICE_NOTIFICATIONS]: "Notification Service",
    },

    settings: {
      chat_room: "Chat room",
      font_size_message: "Font size message",
      background_color: "Background color",
      default: "Default",
      dark: "Dark",
      date: "Date",
      multimedia: "Multimedia",
      date_item: {
        gregorian: "Gregorian",
        hijri_shamsi: "Hijri shamsi",
        hijri_lunar: "Hijri lunar",
      },
      hour_24: "24 hour time",
      show_chanel_vote_layout: "Show chanel vote layout",
      show_sender_name_in_groups: "Show sender name in groups",
      send_by_enter_key: "Send by enter key",
      play_message_sound_in_chat: "Play message sound in chat",
      play_Message_Text_To_Voice: "Text To Voice",
      in_app_browser: "In app browser",
      trim_video: "Trim video",
      compress_video: "Compress video",
      open_video_with_default_player: "Open video with default player",
      crop_and_resize_photo: "Crop and resize photo",
      small_camera_in_attachments: "Small camera in attachments",
      theme_layout: {
        title: "Theme Layout",
        [MessengerThemeLayoutType.WIDE]: "Wide",
        [MessengerThemeLayoutType.BOXED]: "Boxed",
      },
    },
  },
  delete_room_for_owner: {
    [Room.Type.CHANNEL]: "Delete Channel",
    [Room.Type.GROUP]: "Delete Room",
    [Room.Type.CHAT]: "Delete Chat",
  },
  left_room_member: {
    [Room.Type.CHANNEL]: "Channel Left",
    [Room.Type.GROUP]: "Room Left",
    [Room.Type.CHAT]: "Delete Chat",
  },

  storage: {
    saved_file: "Store Multimedia Files",
    saved_file_title: "Disk and Network Usage",
    auto_download_title: "Auto-download Media",
    auto_download: "Auto-download",
    auto_play_media_title: "Auto-play Media",
    auto_play_gif: "Auto Play GIFs",
    auto_play_video: "Auto Play Video",
    local_storage: "Cache",
    clear_local_storage: "Clear Cache",
    saved_file_items: {
      forever: "forever",
      one_week: "one_week",
      six_month: "six_month",
    },
  },
  attachment_menu: {
    contact: "Contact",
    file: "File",
    photo: "Photo",
    camera: "Camera",
    location: "Location",
  },
  callManager: {
    [SignalingOffer.Type.VOICE_CALLING]: "iGap Voice Call",
    [SignalingOffer.Type.VIDEO_CALLING]: "iGap Video Call",
    signaling_status: {
      [SIGNALING_STATUS.CONNECTED]: "Connected...",
      [SIGNALING_STATUS.CONNECTING]: "Connecting...",
      [SIGNALING_STATUS.DISCONNECTED]: "Disconnected...",
      [SIGNALING_STATUS.RINGING]: "Ringing...",
      [SIGNALING_STATUS.CALLING]: "Calling...",
      [SIGNALING_STATUS.REJECTED]: "Rejected...",
      [SIGNALING_STATUS.NOT_ANSWERED]: "Not Answered...",
      [SIGNALING_STATUS.BUSY]: "Busy...",
      [SIGNALING_STATUS.UNAVAILABLE]: "Unavailable...",
    },
  },
  contact_message: {
    add_to_contact: "Add to Contact",
    view_contact: "View Contact",
  },

  copiedInClipboard: "Copied!",
  countries: {
    ad: "Andorra",
    ae: "United Arab Emirates",
    af: "Afghanistan",
    ag: "Antigua & Barbuda",
    ai: "Anguilla",
    al: "Albania",
    am: "Armenia",
    ao: "Angola",
    ar: "Argentina",
    as: "American Samoa",
    at: "Austria",
    au: "Australia",
    aw: "Aruba",
    az: "Azerbaijan",
    ba: "Bosnia & Herzegovina",
    bb: "Barbados",
    bd: "Bangladesh",
    be: "Belgium",
    bf: "Burkina Faso",
    bg: "Bulgaria",
    bh: "Bahrain",
    bi: "Burundi",
    bj: "Benin",
    bm: "Bermuda",
    bn: "Brunei Darussalam",
    bo: "Bolivia",
    bq: "Bonaire, Sint Eustatius & Saba",
    br: "Brazil",
    bs: "Bahamas",
    bt: "Bhutan",
    bw: "Botswana",
    by: "Belarus",
    bz: "Belize",
    ca: "Canada",
    cd: "Congo (Dem. Rep.)",
    cf: "Central African Rep.",
    cg: "Congo (Rep.)",
    ch: "Switzerland",
    ci: "Cote d`Ivoire",
    ck: "Cook Islands",
    cl: "Chile",
    cm: "Cameroon",
    cn: "China",
    co: "Colombia",
    cr: "Costa Rica",
    cu: "Cuba",
    cv: "Cape Verde",
    cw: "Curacao",
    cy: "Cyprus",
    cz: "Czech Republic",
    de: "Germany",
    dj: "Djibouti",
    dk: "Denmark",
    dm: "Dominica",
    do: "Dominican Rep.",
    dz: "Algeria",
    ec: "Ecuador",
    ee: "Estonia",
    eg: "Egypt",
    er: "Eritrea",
    es: "Spain",
    et: "Ethiopia",
    fi: "Finland",
    fj: "Fiji",
    fk: "Falkland Islands",
    fm: "Micronesia",
    fo: "Faroe Islands",
    fr: "France",
    ga: "Gabon",
    gb: "United Kingdom",
    gd: "Grenada",
    ge: "Georgia",
    gf: "French Guiana",
    gh: "Ghana",
    gi: "Gibraltar",
    gl: "Greenland",
    gm: "Gambia",
    gn: "Guinea",
    gp: "Guadeloupe",
    gq: "Equatorial Guinea",
    gr: "Greece",
    gt: "Guatemala",
    gu: "Guam",
    gw: "Guinea-Bissau",
    gy: "Guyana",
    hk: "Hong Kong",
    hn: "Honduras",
    hr: "Croatia",
    ht: "Haiti",
    hu: "Hungary",
    id: "Indonesia",
    ie: "Ireland",
    in: "India",
    io: "Diego Garcia",
    iq: "Iraq",
    ir: "Iran",
    is: "Iceland",
    it: "Italy",
    jm: "Jamaica",
    jo: "Jordan",
    jp: "Japan",
    ke: "Kenya",
    kg: "Kyrgyzstan",
    kh: "Cambodia",
    ki: "Kiribati",
    km: "Comoros",
    kn: "Saint Kitts & Nevis",
    kp: "North Korea",
    kr: "South Korea",
    kw: "Kuwait",
    ky: "Cayman Islands",
    kz: "Kazakhstan",
    la: "Laos",
    lb: "Lebanon",
    lc: "Saint Lucia",
    li: "Liechtenstein",
    lk: "Sri Lanka",
    lr: "Liberia",
    ls: "Lesotho",
    lt: "Lithuania",
    lu: "Luxembourg",
    lv: "Latvia",
    ly: "Libya",
    ma: "Morocco",
    mc: "Monaco",
    md: "Moldova",
    me: "Montenegro",
    mg: "Madagascar",
    mh: "Marshall Islands",
    mk: "Macedonia",
    ml: "Mali",
    mm: "Myanmar",
    mn: "Mongolia",
    mo: "Macau",
    mp: "Northern Mariana Islands",
    mq: "Martinique",
    mr: "Mauritania",
    ms: "Montserrat",
    mt: "Malta",
    mu: "Mauritius",
    mv: "Maldives",
    mw: "Malawi",
    mx: "Mexico",
    my: "Malaysia",
    mz: "Mozambique",
    na: "Namibia",
    nc: "New Caledonia",
    ne: "Niger",
    nf: "Norfolk Island",
    ng: "Nigeria",
    ni: "Nicaragua",
    nl: "Netherlands",
    no: "Norway",
    np: "Nepal",
    nr: "Nauru",
    nu: "Niue",
    nz: "New Zealand",
    om: "Oman",
    pa: "Panama",
    pe: "Peru",
    pf: "French Polynesia",
    pg: "Papua New Guinea",
    ph: "Philippines",
    pk: "Pakistan",
    pl: "Poland",
    pm: "Saint Pierre & Miquelon",
    pr: "Puerto Rico",
    ps: "Palestine",
    pt: "Portugal",
    pw: "Palau",
    py: "Paraguay",
    qa: "Qatar",
    re: "Reunion",
    ro: "Romania",
    rs: "Serbia",
    ru: "Russian Federation",
    rw: "Rwanda",
    sa: "Saudi Arabia",
    sb: "Solomon Islands",
    sc: "Seychelles",
    sd: "Sudan",
    se: "Sweden",
    sg: "Singapore",
    sh: "Saint Helena",
    si: "Slovenia",
    sk: "Slovakia",
    sl: "Sierra Leone",
    sm: "San Marino",
    sn: "Senegal",
    so: "Somalia",
    sr: "Suriname",
    ss: "South Sudan",
    st: "Sao Tome & Principe",
    sv: "El Salvador",
    sx: "Sint Maarten",
    sy: "Syria",
    sz: "Swaziland",
    tc: "Turks & Caicos Islands",
    td: "Chad",
    tg: "Togo",
    th: "Thailand",
    tj: "Tajikistan",
    tk: "Tokelau",
    tl: "Timor-Leste",
    tm: "Turkmenistan",
    tn: "Tunisia",
    to: "Tonga",
    tr: "Turkey",
    tt: "Trinidad & Tobago",
    tv: "Tuvalu",
    tw: "Taiwan",
    tz: "Tanzania",
    ua: "Ukraine",
    ug: "Uganda",
    us: "USA",
    uy: "Uruguay",
    uz: "Uzbekistan",
    vc: "Saint Vincent & the Grenadines",
    ve: "Venezuela",
    vg: "British Virgin Islands",
    vi: "US Virgin Islands",
    vn: "Vietnam",
    vu: "Vanuatu",
    wf: "Wallis & Futuna",
    ws: "Samoa",
    ye: "Yemen",
    yl: "Y-land",
    za: "South Africa",
    zm: "Zambia",
    zw: "Zimbabwe",
  },
  create_conversation_popup: {
    channel_type: {
      link_info: "If you set a permanent link, other people will be able to find and join your channel. You can use a-z, 0-9 and underscores. Minimum length is 5 characters.",
      permanent_link: "Permanent Link",
      private_channel: "Private Channel",
      private_channel_info: "Not anyone can join. They can only be added as members by the admin(s).",
      public_channel: "Public Channel",
      public_channel_info: "Anyone can join public channels via searching or receiving the invitation link.",
      your_link: "Your Link",
    },
    create_conversation: "Create Conversation",
    new_channel: "New Channel",
    new_contact: "New Contact",
    new_group: "New Group",
  },
  date: {
    ago: "Ago",
    day: "Day",
    hour: "Hour",
    later: "Later",
    long_time_ago: "Long time ago",
    minute: "Minutes",
    month: "Month",
    recently: "Recently",
    second: "Second",
    week: "Week",
    year: "Year",
    few_moment_ago: "Few moments ago",
  },
  restrictions_media: "Restrictions on sending multimedia messages!",
  restrictions_message: "Restrictions on sending messages",
  registered_user_status: {
    support: "Support",
    service_notification: "Notification Services",
  },
  emoji_tabs: {
    emoji: "Emoji",
    gif: "Gif",
    sticker: "Sticker",
  },
  errors: {
    "1": "The request is not valid",
    "2": "You have to log in first, then ask for performing this action",
    "3": "New client just connected to this session, you are not allowed to continue",
    "4": "This operation is not permitted",
    "5": "Getting response from the server has been timed out",
    "6": "For related requests; if one gets error, RELATION_ERROR will be sent to the others",
    "8": "Your session has been terminated by another device",
    "9": "Nickname is required to be set before continue to do the action",
    "10": "You have exceeded the number of requests allowed",
    "100": "Bad payload",
    "102": "Bad payload",
    "104": "There is no registered user with this given username",
    "105": "Your user account is blocked, you cannot verify the user",
    "106": "Verification code is incorrect",
    "107": "The Verification Code you entered has expired",
    "108": "The Verification Code is locked now due to many tries",
    "109": "Bad payload",
    "111": "Login failed",
    "112": "Bad payload",
    "114": "Bad payload",
    "116": "Bad payload",
    "118": "Bad payload",
    "120": "Bad payload",
    "122": "Bad payload",
    "124": "Bad payload",
    "126": "Bad payload",
    "128": "Bad payload",
    "130": "Bad payload",
    "135": "Your user account is blocked",
    "136": "The verification code was entered incorrectly too many times. Please try again later",
    "137": "You have requested the verification code exceedingly",
    "138": "Bad payload",
    "140": "You are forbidden to do the action",
    "141": "Bad payload",
    "143": "You are forbidden to do the action",
    "144": "Bad payload",
    "146": "You are forbidden to do the action",
    "147": "Bad payload",
    "149": "You are forbidden to do the action",
    "150": "Bad payload",
    "152": "Destruction Code for deleting user account has been entered incorrectly too many times",
    "153": "Destruction Code for deleting user account has been requested too many times",
    "154": "Bad payload",
    "156": "Account destruction token is incorrect",
    "157": "Account destruction token you entered has expired",
    "158": "Destruction Code for deleting user account has been entered incorrectly too many times",
    "159": "Bad payload",
    "161": "Bad payload",
    "164": "Bad payload",
    "166": "Bad payload",
    "168": "Bad payload",
    "170": "Bad payload",
    "172": "You are forbidden to do the action",
    "173": "Bad payload",
    "175": "The username has been recently updated; please keep waiting until you can renew it or choose the latest one again",
    "176": "Bad payload",
    "178": "There is no user with this UserID",
    "179": "Bad payload",
    "181": "This user has already been unblocked",
    "182": "Bad payload",
    "184": "Two-step Verification is activated",
    "185": "Bad payload",
    "187": "You are forbidden to do the action",
    "188": "You have not activated Two-step Verification yet",
    "189": "Bad payload",
    "191": "Password has been entered incorrectly too many times",
    "192": "You are forbidden to do the action",
    "193": "Password has not been set yet",
    "194": "Password is incorrect",
    "195": "Bad payload",
    "197": "Password has been entered incorrectly too many times",
    "198": "The old password in not correct",
    "199": "Bad payload",
    "200": "Bad payload",
    "202": "There is no active user with the given peer_ID",
    "203": "Bad payload",
    "205": "You are forbidden to do the action",
    "206": "Bad payload",
    "208": "You are forbidden to do the action",
    "209": "Bad payload",
    "211": "You are forbidden to do the action",
    "212": "Bad payload",
    "214": "You are forbidden to do the action",
    "215": "Bad payload",
    "217": "You are forbidden to do the action",
    "218": "Bad payload",
    "220": "You are forbidden to do the action",
    "221": "Bad payload",
    "223": "You are forbidden to do the action",
    "224": "Bad payload",
    "226": "You are forbidden to do the action",
    "227": "Bad payload",
    "229": "You are forbidden to do the action",
    "230": "Bad payload",
    "232": "You are forbidden to do the action",
    "233": "You have got blocked by the peer",
    "234": "You are not currently allowed to send message to the required recipient for the restriction made",
    "300": "Bad payload",
    "302": "Bad payload",
    "304": "This user has already joined this room",
    "305": "You are forbidden to do the action",
    "306": "Bad payload",
    "308": "You are forbidden to do the action",
    "309": "Bad payload",
    "311": "You are forbidden to do the action",
    "312": "Bad payload",
    "314": "You are forbidden to do the action",
    "315": "Bad payload",
    "317": "You are forbidden to do the action",
    "318": "Bad payload",
    "320": "You are forbidden to do the action",
    "321": "Bad payload in",
    "323": "You are forbidden to do the action",
    "324": "Bad payload",
    "326": "You are forbidden to do the action",
    "327": "Bad payload",
    "329": "You are forbidden to do the action",
    "330": "Bad payload",
    "332": "Bad payload",
    "334": "You are forbidden to do the action",
    "335": "Bad payload",
    "337": "You are forbidden to do the action",
    "338": "Bad payload",
    "340": "You are forbidden to do the action",
    "341": "Bad payload",
    "343": "You are forbidden to do the action",
    "344": "Bad payload",
    "346": "You are forbidden to do the action",
    "347": "Bad payload",
    "349": "You are forbidden to do the action",
    "350": "Bad payload",
    "352": "You are forbidden to do the action",
    "353": "Bad payload",
    "355": "You are forbidden to do the action",
    "356": "Bad payload",
    "358": "You are forbidden to do the action",
    "359": "Bad payload",
    "361": "You are forbidden to do the action",
    "362": "No more member can join this room",
    "363": "You are forbidden to do the action",
    "364": "Bad payload",
    "366": "Bad payload",
    "368": "Username has been changed recently, to renew it wait until the allowed time or choose the last one again",
    "369": "You are forbidden to do the action",
    "370": "Bad payload",
    "372": "You are forbidden to do the action",
    "373": "Bad payload",
    "375": "You are forbidden to do the action",
    "376": "Bad payload",
    "378": "You are forbidden to do the action",
    "379": "You cannot invite this user to groups because of the protected privacy",
    "380": "You are restricted to create more rooms",
    "381": "Bad payload",
    "383": "You are forbidden to do the action",
    "400": "Bad payload",
    "402": "Bad payload",
    "404": "This user has already joined this room",
    "405": "You are forbidden to do the action",
    "406": "Bad payload",
    "408": "You are forbidden to do the action",
    "409": "Bad payload",
    "411": "You are forbidden to do the action",
    "412": "Bad payload",
    "414": "You are forbidden to do the action",
    "415": "Bad payload",
    "417": "You are forbidden to do the action",
    "418": "Bad payload",
    "420": "You are forbidden to do the action",
    "421": "Bad payload in",
    "423": "You are forbidden to do the action",
    "424": "Bad payload",
    "426": "You are forbidden to do the action",
    "427": "Bad payload",
    "429": "You are forbidden to do the action",
    "430": "Bad payload",
    "432": "Bad payload",
    "434": "You are forbidden to do the action",
    "435": "Bad payload",
    "437": "You are forbidden to do the action",
    "438": "Bad payload",
    "440": "You are forbidden to do the action",
    "441": "Bad payload",
    "443": "You are forbidden to do the action",
    "444": "Bad payload",
    "446": "You are forbidden to do the action",
    "447": "Bad payload",
    "449": "You are forbidden to do the action",
    "450": "Bad payload",
    "452": "You are forbidden to do the action",
    "453": "Bad payload",
    "455": "Bad payload",
    "457": "Username has been changed recently, to renew it wait until the allowed time or choose the last one again",
    "458": "You are forbidden to do the action",
    "459": "You are forbidden to do the action",
    "460": "Bad payload",
    "462": "You are forbidden to do the action",
    "463": "Bad payload",
    "465": "You are forbidden to do the action",
    "466": "Bad payload",
    "468": "You are forbidden to do the action",
    "469": "Bad payload",
    "471": "You are forbidden to do the action",
    "472": "Bad payload",
    "474": "You are forbidden to do the action",
    "475": "Bad payload",
    "477": "You are forbidden to do the action",
    "478": "You cannot invite this user to groups because of the protected privacy",
    "479": "You are restricted to create more rooms",
    "480": "Bad payload",
    "482": "You are forbidden to do the action",
    "483": "Bad payload",
    "485": "You are forbidden to do the action",
    "500": "Location could not be found",
    "501": "Bad payload",
    "502": "Bad payload",
    "504": "Bad payload",
    "600": "Bad payload",
    "602": "Virtual Error",
    "603": "Virtual Error",
    "604": "Virtual Error",
    "605": "Virtual Error",
    "606": "Virtual Error",
    "607": "Virtual Error",
    "608": "Virtual Error",
    "609": "Virtual Error",
    "610": "Bad payload",
    "612": "Bad payload",
    "614": "No Such room ",
    "615": "Bad payload",
    "617": "There is no other massage to view",
    "618": "Bad payload",
    "620": "There is no other massage to view",
    "621": "Bad payload",
    "623": "There is no user ",
    "624": "Bad payload",
    "626": "The requested message could not be found",
    "627": "Bad payload",
    "629": "Invite Link of the room is invalid",
    "630": "Bad payload",
    "632": "You are forbidden to do the action",
    "633": "The user has already joined this room",
    "634": "No other user is accepted to join this room because of the allowed number reached",
    "635": "Bad payload",
    "637": "You are forbidden to do the action",
    "638": "The user has already joined this room",
    "639": "No other user is accepted to join this room because of the allowed number reached",
    "640": "Bad payload",
    "642": "You are forbidden to do the action",
    "643": "Bad payload",
    "645": "Bad payload",
    "647": "Bad payload",
    "649": "No such room was found",
    "650": "Bad payload",
    "652": "You are forbidden to do the action",
    "653": "Bad payload",
    "655": "You are forbidden to do the action",
    "656": "Bad payload",
    "658": "You have already reported this message/room",
    "659": "You are forbidden to do the action",
    "660": "Bad payload",
    "661": "You are forbidden to do the action",
    "663": "Bad payload",
    "664": "You are forbidden to do the action",
    "665": "You are forbidden to do the action",
    "666": "Bad payload",
    "667": "You are forbidden to do the action",
    "668": "Bad payload",
    "669": "You are forbidden to do the action",
    "670": "Bad payload",
    "671": "You are forbidden to do the action",
    "672": "Bad payload",
    "673": "You are forbidden to do the action",
    "674": "Bad payload",
    "675": "You are forbidden to do the action",
    "676": "Bad payload",
    "677": "You are forbidden to do the action",
    "700": "Bad payload",
    "702": "Bad payload",
    "704": "Bad payload",
    "706": "You are forbidden to do the action",
    "707": "Bad payload",
    "709": "No such file was found",
    "710": "Bad payload",
    "712": "No such file was found",
    "713": "Bad payload",
    "715": "No such file was found",
    "800": "Bad payload",
    "802": "Bad payload",
    "804": "Bad payload",
    "806": "Bad payload",
    "808": "Bad payload",
    "900": "Bad payload",
    "902": "Bad payload",
    "904": "You are forbidden to do the action",
    "905": "You have got blocked by the peer",
    "906": "You cannot call this user because of the protected privacy",
    "907": "Bad payload",
    "909": "You are forbidden to do the action",
    "910": "Bad payload",
    "912": "You are forbidden to do the action",
    "913": "Bad payload",
    "915": "You are forbidden to do the action",
    "916": "Bad payload",
    "918": "You are forbidden to do the action",
    "921": "You are forbidden to do the action",
    "922": "Bad payload",
    "926": "Bad payload",
    "928": "You are forbidden to do the action",
    "1000": "Bad payload",
    "1002": "Bad payload",
    "1004": "Bad payload",
    "1006": "You are forbidden to do the action",
    "1007": "Bad payload",
    "1009": "You are forbidden to do the action",
    "1010": "Bad payload",
    "1012": "You are forbidden to do the action",
    "1013": "Bad payload",
    "1015": "You are forbidden to do the action",
    "1016": "Bad payload",
    "1018": "You are forbidden to do the action",
    "9000": "Bad payload",
    "9002": "Server was not able to get a valid or any response from the Wallet server",
    "9003": "You are forbidden to do the action",
    "9004": "Bad payload",
    "9006": "Server was not able to get a valid or any response from the Wallet server",
    "9007": "You are forbidden to do the action",
    "9008": "Recipient are forbidden",
    "9009": "Error from Wallet server",
    "9010": "Recipient is not registered in wallet",
    "9011": "Bad payload",
    "9013": "You are forbidden to do the action",
    "9014": "Bad payload",
    "9016": "No such user was found",
    "9100": "Bad payload",
    "9102": "Server was not able to get a valid or any response from the Mpl server",
    "9103": "You are forbidden to do the action",
    "9104": "Bad payload",
    "9106": "Server was not able to get a valid or any response from the Mpl server",
    "9107": "You are forbidden to do the action",
    "9108": "Bad payload",
    "9110": "Server was not able to get a valid or any response from the Mpl server",
    "9111": "You are forbidden to do the action",
    "9112": "Bad payload",
    "9114": "Server was not able to get a valid or any response from the Mpl server",
    "9115": "You are forbidden to do the action",
    "9116": "Bad payload",
    "9118": "Server was not able to get a valid or any response from the Mpl server",
    "9119": "You are forbidden to do the action",
    "9120": "Bad payload",
    "9121": "You are forbidden to do the action",
    "9122": "Server was not able to get a valid or any response from the Mpl server",
    "9123": "Bad payload",
    "9125": "Bad payload",
    "9127": "Server was not able to get a valid or any response from the Mpl server",
    "9128": "You are forbidden to do the action",
    "9200": "Bad payload",
    "9202": "Server was not able to get a valid or any response from the bill inquiry server",
    "9203": "You are forbidden to do the action",
    "9204": "Bad payload",
    "9206": "Server was not able to get a valid or any response from the bill inquiry server",
    "9207": "You are forbidden to do the action",
    "10101": "Password has been entered incorrectly too many times",
    "10102": "Password is not valid",
    "10103": "Bad payload",
    "10105": "Password is not correct",
    "10106": "Password has been entered incorrectly too many times",
    "10107": "Password has not been set yet",
    "10108": "Bad payload",
    "10110": "The code to verify the recovery E-mail has been entered incorrectly too many times",
    "10111": "The code to verify and authenticate recovery E-mail has expired",
    "10112": "Password has not been set yet",
    "10113": "The verification code you entered for E-mail recovery is incorrect",
    "10114": "Bad payload",
    "10116": "The code to verify the recovery E-mail has been entered incorrectly too many times",
    "10117": "Password has not been set yet",
    "10118": "Password is incorrect",
    "10119": "Recovery E-mail has already been confirmed",
    "10120": "Bad payload",
    "10122": "Password has not been set yet",
    "10123": "No E-mail has been set to recover password",
    "10124": "Password recovery token has been entered incorrectly too many times",
    "10125": "Bad payload",
    "10127": "Password recovery token has been entered incorrectly too many times",
    "10128": "Password recovery token has expired",
    "10129": "Password recovery token is invalid",
    "10130": "Password has not been set yet",
    "10131": "Bad payload",
    "10133": "Password has been entered incorrectly too many times",
    "10134": "At least one of the answers is not valid",
    "10135": "Password has not been set yet",
    "10136": "Bad payload",
    "10138": "Password has been entered incorrectly too many times",
    "10139": "Password has not been set yet",
    "10140": "Password is incorrect",
    "10141": "Bad payload",
    "10143": "Password has been entered incorrectly too many times",
    "10144": "Password has not been set yet",
    "10145": "Password is incorrect",
    "10146": "Bad payload",
    "10148": "Bad payload",
    "10150": "Bad payload",
    "10152": "Token is invalid",
    "10153": "Token has expired",
    "10154": "You are forbidden to do the action",
    "10155": "You are forbidden to do the action",
    "10156": "You are forbidden to do the action",
    "10157": "Bad payload",
    "10159": "Password has not been set yet",
    "10160": "There is no confirmed E-mail to be sent the verification token",
    "10161": "Bad payload",
    "10163": "Bad payload",
    "10165": "Bad payload",
    "10167": "You have already reported this user",
    "10168": "You are forbidden to do the action",
    "10169": "You are forbidden to do the action",
    "10170": "You are forbidden to login again",
    "10171": "You are forbidden to do the action due to wallet restriction",
    "10172": "Server was not able to get a valid or any response from the Wallet server",
    "10173": "Bad payload",
    "10175": "Bad payload",
    "10177": "Bad payload",
    "10179": "Bad payload",
    "10182": "Bad payload",
    "100_1": "Country code is invalid",
    "100_2": "Username is invalid",
    "100_3": "PreferenceMethod is invalid",
    "102_1": "Verification code is invalid",
    "102_2": "Username is invalid",
    "109_1": "Token is invalid",
    "109_2": "App Name is invalid",
    "109_3": "App ID is invalid",
    "109_4": "App Build Version is invalid",
    "109_5": "App Version is invalid",
    "109_6": "Platform is invalid",
    "109_7": "Device is invalid",
    "109_8": "Device Name is invalid",
    "109_9": "Language is invalid",
    "111_4": "Your account is blocked",
    "116_1": "Gender is invalid",
    "118_1": "Phone Number is not valid",
    "118_2": "First Name is not valid",
    "118_3": "Last Name is not valid",
    "118_4": "Force is not valid",
    "118_5": "Too many contacts",
    "122_1": "Phone Number is not valid",
    "122_invalid": "Phone Number is not valid",
    "124_1": "Phone Number is invalid",
    "124_2": "First Name is invalid",
    "124_3": "Last Name is invalid",
    "124_4": "It's required to enter first name or last name",
    "138_1": "Attachment is not valid",
    "141_1": "Avatar_ID is invalid",
    "144_1": "User_ID is invalid",
    "147_1": "User_ID is incorrect",
    "154_1": "Account destruction token is incorrect",
    "154_2": "Account destruction reason is not valid",
    "161_1": "Self_Remove is invalid",
    "164_2": "Username is invalid",
    "164_3": "This username has already been taken",
    "166_1": "Status is incorrect",
    "170_1": "Session_ID is invalid",
    "173_1": "Session_ID is invalid",
    "176_1": "User_ID is incorrect",
    "179_1": "User_ID is incorrect",
    "189_1": "Password is wrong",
    "195_1": "Old Password is wrong",
    "195_2": "New Password is invalid",
    "195_3": "Recovery E-mail is not valid",
    "195_4": "Recovery E-mail is not valid",
    "195_5": "The first recovery question is invalid",
    "195_6": "Answer of the first recovery question is invalid",
    "195_7": "The second recovery question is invalid",
    "195_8": "Answer of the second recovery question is invalid",
    "195_9": "Password hint is not valid",
    "199_1": "Password is invalid",
    "200_1": "Peer_ID is invalid",
    "202_3": "Peer's account has got blocked",
    "203_1": "Room_ID is invalid",
    "203_2": "Message is invalid",
    "203_3": "Attachment is invalid",
    "203_4": "Attachment is invalid",
    "203_5": "Attachment is invalid",
    "203_6": "Attachment is invalid",
    "203_7": "Attachment is invalid",
    "203_8": "Attachment is invalid",
    "203_9": "Message is invalid",
    "203_10": "Attachment is invalid",
    "203_11": "Message is invalid",
    "203_12": "Attachment is invalid",
    "203_13": "Message is invalid",
    "203_14": "Attachment is invalid",
    "203_15": "Message is invalid",
    "203_16": "Attachment is invalid",
    "203_17": "Location is invalid",
    "203_18": "Location.lat is invalid",
    "203_19": "Location.lon is invalid",
    "203_22": "Contact is invalid",
    "203_23": "Message_Type is invalid",
    "203_24": "No such file is found",
    "203_25": "ReplyTo is invalid",
    "203_26": "ForwardFrom.Room_ID is invalid",
    "203_27": "ForwardFrom.Message_ID is invalid",
    "203_28": "ForwardFrom is invalid",
    "203_29": "ReplyTo and ForwardFrom have been set",
    "203_30": "Message is invalid",
    "203_31": "Attachment is invalid",
    "203_32": "Message is too long",
    "203_33": "Random id is invalid",
    "203_34": "additional_type is invalid",
    "203_35": "additional_data invalid",
    "203_36": "Sticker Message invalid",
    "203_37": "Sticker Data invalid",
    "206_1": "Room_ID is invalid",
    "206_2": "Message_ID is invalid",
    "209_1": "Room_ID is invalid",
    "209_2": "Message_ID is invalid",
    "209_3": "Message is invalid",
    "212_1": "Room_ID is invalid",
    "212_2": "Message_ID is invalid",
    "212_3": "Both are invalid",
    "215_1": "Room_ID is invalid",
    "215_2": "Clear_ID is invalid",
    "218_1": "Room_ID is invalid",
    "221_1": "Room_ID is invalid",
    "221_2": "Message_ID is invalid",
    "221_3": "ReplyTo is invalid",
    "224_1": "Room_ID is invalid",
    "227_1": "Room_ID is invalid",
    "227_2": "Group Name is not valid",
    "227_3": "Group Description is not valid",
    "230_1": "Room_ID is invalid",
    "230_2": "Action is wrong",
    "230_3": "Action_ID is not valid",
    "300_1": "Room_Name for Group is invalid",
    "300_2": "Group Description is invalid",
    "302_1": "Room_ID is invalid",
    "302_2": "User_ID is invalid",
    "302_3": "StartMessage_ID is invalid",
    "306_1": "Room_ID is invalid",
    "306_2": "Message is invalid",
    "306_3": "Attachment is invalid",
    "306_4": "Attachment is invalid",
    "306_5": "Attachment is invalid",
    "306_6": "Attachment is invalid",
    "306_7": "Attachment is invalid",
    "306_8": "Attachment is invalid",
    "306_9": "Message is invalid",
    "306_10": "Attachment is invalid",
    "306_11": "Message is invalid",
    "306_12": "Attachment is invalid",
    "306_13": "Message is invalid",
    "306_14": "Attachment is invalid",
    "306_15": "Message is invalid",
    "306_16": "Attachment is invalid",
    "306_17": "Location is invalid",
    "306_18": "Location.lat is invalid",
    "306_19": "Location.lon is invalid",
    "306_22": "Contact is invalid",
    "306_23": "Message_Type is invalid",
    "306_24": "No such file is found",
    "306_25": "ReplyTo is invalid",
    "306_26": "ForwardFrom.Room_ID is invalid",
    "306_27": "ForwardFrom.Message_ID is invalid",
    "306_28": "ForwardFrom is invalid",
    "306_29": "ReplyTo and ForwardFrom have been set",
    "306_30": "Message is invalid",
    "306_31": "Attachment is invalid",
    "306_32": "Message is too long",
    "306_33": "Random id is invalid",
    "306_34": "additional_type is invalid",
    "306_35": "additional_data invalid",
    "306_36": "Sticker Message invalid",
    "306_37": "Sticker Data invalid",
    "309_1": "Room_ID is invalid",
    "309_2": "Message_ID is invalid",
    "309_3": "Status is invalid",
    "312_1": "Room_ID is invalid",
    "312_2": "Message_ID is invalid",
    "315_1": "Room_ID is invalid",
    "315_2": "Clear_ID is invalid",
    "318_1": "Room_ID is invalid",
    "318_2": "Member_ID is invalid",
    "321_1": "Room_ID is invalid",
    "321_2": "Member_ID is invalid",
    "324_1": "Room_ID is invalid",
    "324_2": "Member_ID is invalid",
    "327_1": "Room_ID is invalid",
    "327_2": "Member_ID is invalid",
    "330_1": "Room_ID is invalid",
    "330_2": "Group Name is invalid",
    "330_3": "Group Description is invalid",
    "332_1": "Room_ID is invalid",
    "332_2": "Member_ID is invalid",
    "335_1": "Room_ID is invalid",
    "338_1": "Attachment is invalid",
    "338_2": "Room_ID is invalid",
    "341_1": "Avatar_ID is invalid",
    "341_2": "Room_ID is invalid",
    "347_1": "Room_ID is invalid",
    "347_2": "Message_ID is invalid",
    "347_3": "ReplyTo is invalid",
    "350_1": "Room_ID is invalid",
    "353_1": "Room_ID is invalid",
    "353_2": "FilterRole is invalid",
    "353_3": "OffSet is invalid",
    "353_4": "Limit is",
    "356_1": "Room_ID is invalid",
    "359_1": "Room_ID is invalid",
    "359_2": "Action is wrong",
    "359_3": "Action_ID is not valid",
    "364_1": "Room_ID is invalid",
    "366_1": "Room_ID is invalid",
    "366_2": "Username is invalid",
    "366_3": "This username has already been taken by another user",
    "366_4": "More than the allowed usernames have been selected by you",
    "370_1": "Room_ID is invalid",
    "373_1": "Room_ID is invalid",
    "376_1": "Room_ID is invalid",
    "376_2": "Message_ID is invalid",
    "376_3": "Message is invalid",
    "381_1": "Room_ID is invalid",
    "381_2": "Message_ID is invalid",
    "400_1": "Room_Name for Channel is invalid",
    "400_2": "Channel Description is invalid",
    "402_1": "Room_ID is invalid",
    "402_2": "User_ID_Member is invalid",
    "406_1": "Room_ID is invalid",
    "406_2": "Message is invalid",
    "406_3": "Attachment is invalid",
    "406_4": "Attachment is invalid",
    "406_5": "Attachment is invalid",
    "406_6": "Attachment is invalid",
    "406_7": "Attachment is invalid",
    "406_8": "Attachment is invalid",
    "406_9": "Message is invalid",
    "406_10": "Attachment is invalid",
    "406_11": "Message is invalid",
    "406_12": "Attachment is invalid",
    "406_13": "Message is invalid",
    "406_14": "Attachment is invalid",
    "406_15": "Message is invalid",
    "406_16": "Attachment is invalid",
    "406_17": "Location is invalid",
    "406_18": "Location.lat is invalid",
    "406_19": "Location.lon is invalid",
    "406_22": "Contact is invalid",
    "406_23": "Message_Type is invalid",
    "406_24": "No such file is found",
    "406_25": "ReplyTo is invalid",
    "406_26": "ForwardFrom.Room_ID is invalid",
    "406_27": "ForwardFrom.Message_ID is invalid",
    "406_28": "ForwardFrom is invalid",
    "406_29": "ReplyTo and ForwardFrom have been set",
    "406_30": "Message is invalid",
    "406_31": "Attachment is invalid",
    "406_32": "Message is too long",
    "406_33": "Random id is invalid",
    "406_34": "additional_type is invalid",
    "406_35": "additional_data invalid",
    "406_36": "Sticker Message invalid",
    "406_37": "Sticker Data invalid",
    "409_1": "Room_ID is invalid",
    "412_1": "Room_ID is invalid",
    "412_2": "Message_ID is invalid",
    "415_1": "Room_ID is invalid",
    "415_2": "FilterRole is invalid",
    "415_3": "OffSet is invalid",
    "415_4": "Limit is",
    "418_1": "Room_ID is invalid",
    "418_2": "Member_ID is invalid",
    "421_1": "Room_ID is invalid",
    "421_2": "Member_ID is invalid",
    "424_1": "Room_ID is invalid",
    "424_2": "Member_ID is invalid",
    "427_1": "Room_ID is invalid",
    "427_2": "Member_ID is invalid",
    "430_1": "Room_ID is invalid",
    "430_2": "Channel Name is invalid",
    "430_3": "Channel Description is invalid",
    "432_1": "Room_ID is invalid",
    "432_2": "Member_ID is invalid",
    "435_1": "Room_ID is invalid",
    "438_1": "Attachment is invalid",
    "438_2": "Room_ID is invalid",
    "441_1": "Avatar_ID is invalid",
    "441_2": "Room_ID is invalid",
    "447_1": "Room_ID is invalid",
    "447_2": "Message_ID is invalid",
    "447_3": "ReplyTo is invalid",
    "450_1": "Room_ID is invalid",
    "453_1": "Room_ID is invalid",
    "455_1": "Room_ID is invalid",
    "455_2": "Username is invalid",
    "455_3": "This username has already been taken by another user",
    "455_4": "More than the allowed usernames have been selected by you",
    "460_1": "Room_ID is invalid",
    "463_1": "Room_ID is invalid",
    "466_1": "Room_ID is invalid",
    "466_2": "Signature is invalid",
    "469_1": "Room_ID is invalid",
    "469_2": "At least one message is required",
    "469_3": "Number of messages is more than the allowed",
    "469_4": "Message_ID is invalid",
    "472_1": "Room_ID is invalid",
    "472_2": "Message_ID is invalid",
    "472_3": "Reaction is invalid",
    "475_1": "Room_ID is invalid",
    "475_2": "Message_ID is invalid",
    "475_3": "Message is invalid",
    "480_1": "Room_ID is invalid",
    "480_2": "reaction_status is invalid",
    "483_1": "Room_ID is invalid",
    "483_2": "Message_ID is invalid",
    "501_1": "IsoCode is invalid",
    "502_1": "ID is Wrong",
    "504_1": "Fit is invalid",
    "600_1": "Room_ID is invalid",
    "600_2": "MessageVersion is invalid",
    "600_3": "StatusVersion is invalid",
    "600_4": "DeleteVersion is invalid",
    "600_5": "OfflineDeleted is invalid",
    "600_6": "OfflineEdited.Message_ID is invalid",
    "600_7": "OfflineEdited.Message is invalid",
    "600_8": "OfflineSeen is invalid",
    "600_9": "Clear_ID is invalid",
    "600_10": "CacheStart_ID is invalid",
    "600_11": "CacheEnd_ID is invalid",
    "600_12": "OfflineMute is invalid",
    "600_13": "Your request is totally wrong",
    "600_14": "OfflineListened is invalid",
    "600_15": "Your request is totally wrong",
    "600_16": "OfflineDeletedDeprecated & OfflineDeleted have been set both",
    "600_17": "OfflineDeleted.Message_ID is invalid",
    "600_18": "OfflineDeleted.both is invalid",
    "610_1": "OffSet is invalid",
    "610_2": "Limit is invalid",
    "612_1": "Room_ID is invalid",
    "615_1": "Room_ID is invalid",
    "615_2": "FirstMessage_ID is invalid",
    "615_3": "Direction is wrong",
    "615_4": "Limit is invalid",
    "618_1": "Room_ID is invalid",
    "618_2": "OffSet is invalid",
    "618_3": "Filter is invalid",
    "618_4": "OffSet.Message_ID is invalid",
    "621_1": "Username is incorrect",
    "624_1": "Room_ID is invalid",
    "624_2": "Message_ID is invalid",
    "627_1": "Invite Token is not valid",
    "630_1": "Invite Token is not valid",
    "635_1": "Username is invalid",
    "640_1": "Room_ID is invalid",
    "643_1": "Room_ID is invalid",
    "645_1": "Query is invalid",
    "647_1": "Room_ID is invalid",
    "650_1": "Room_ID is invalid",
    "650_2": "RoomMute is invalid",
    "653_1": "Room_ID is invalid",
    "653_2": "PIN is invalid",
    "656_1": "Room_ID is invalid",
    "656_2": "Message_ID is invalid",
    "656_3": "Reason is invalid",
    "656_4": "Description is",
    "660_1": "token is invalid",
    "660_2": "type is invalid",
    "674_1": "Poll ID",
    "674_2": "Project ID",
    "676_1": "ITEM ID",
    "677_1": "Error in get poll",
    "677_2": "Poll not found",
    "677_3": "Poll not found",
    "677_4": "Error in get poll count",
    "677_5": "Poll count not found",
    "677_6": "Maximum vote limit",
    "677_7": "Cache Error",
    "677_8": "Duplicate entry",
    "700_1": "Size is invalid",
    "702_1": "Size is invalid",
    "702_2": "First bytes are invalid",
    "702_3": "Last bytes are invalid",
    "702_4": "FileHash is invalid",
    "702_5": "FileName is invalid",
    "704_1": "Token is invalid",
    "704_2": "OffSet is invalid",
    "704_3": "OffSet is invalid",
    "704_4": "Bytes are invalid",
    "707_1": "Token is invalid",
    "710_1": "Token is invalid",
    "713_1": "Token is invalid",
    "713_2": "OffSet is invalid",
    "713_3": "MaxLimit is invalid",
    "713_4": "Selector is invalid",
    "800_1": "InviteToken is invalid",
    "802_1": "Username is invalid",
    "802_2": "Message_ID is invalid",
    "804_1": "AppName is invalid",
    "804_2": "App_ID is invalid",
    "804_3": "AppBuildVersion is invalid",
    "804_4": "AppVersion is invalid",
    "804_5": "Platform is invalid",
    "804_6": "PlatformVersion is invalid",
    "804_7": "Device is invalid",
    "804_8": "DeviceName is invalid",
    "806_1": "Phone is invalid",
    "806_2": "First name is invalid",
    "806_3": "Last name is invalid",
    "902_1": "CalledUser_ID is invalid",
    "902_2": "Type is invalid",
    "902_3": "Caller_SDP is invalid",
    "910_1": "Called_SDP is invalid",
    "913_1": "Candidate is invalid",
    "913_2": "SDP_MID is invalid",
    "913_3": "SDP_M_Line_Index is invalid",
    "919_1": "Hold is invalid",
    "922_1": "Pagination is invalid",
    "922_2": "OffSet is invalid",
    "922_3": "Limit is invalid",
    "924_1": "Clear_ID is invalid",
    "926_1": "ID is invalid",
    "926_2": "Rate is invalid",
    "926_3": "Reason is invalid",
    "1002_1": "Enable is invalid",
    "1004_1": "Lat is invalid",
    "1004_2": "Lon is invalid",
    "1007_1": "User_ID is invalid",
    "1010_1": "Comment is invalid",
    "1013_1": "Lat is invalid",
    "1013_2": "Lon is invalid",
    "1016_1": "Lat is invalid",
    "1016_2": "Lon is invalid",
    "9004_1": "language is invalid",
    "9004_2": "jwt is invalid",
    "9004_3": "to_user_id is invalid",
    "9004_4": "amount is invalid",
    "9004_5": "description is invalid",
    "9014_1": "wallet_id is invalid",
    "9100_1": "bill_id is invalid",
    "9100_2": "pay_id is invalid",
    "9104_1": "charge_mobile_number is invalid",
    "9104_3": "amount is invalid",
    "9108_1": "amount is invalid",
    "9108_2": "to_id is invalid",
    "9108_3": "invoice number is invalid",
    "9108_4": "description is invalid",
    "9108_5": "Inquiry is invalid",
    "9112_1": "data in invalid",
    "9112_2": "PayData is not exist",
    "9112_3": "PayData is invalid",
    "9120_1": "invoice number is invalid",
    "9120_2": "Confirm or reverse is invalid",
    "9123_1": "Status is invalid",
    "9123_2": "Pagination is invalid",
    "9125_1": "Data is invalid",
    "9125_2": "To user id is invalid",
    "9200_1": "mobile_number is invalid",
    "9204_1": "province_code is invalid",
    "9204_2": "telephone_number is invalid",
    "10103_1": "Password is not correct",
    "10108_1": "Token is incorrect",
    "10114_1": "Password is incorrect",
    "10114_2": "Recovery E-mail is incorrect",
    "10114_3": "Recovery E-mail is incorrect",
    "10125_1": "Token is incorrect",
    "10131_1": "The first answer is incorrect",
    "10131_2": "The second answer is incorrect",
    "10136_1": "Password is incorrect",
    "10136_2": "The first question is invalid",
    "10136_3": "Answer of the first question is incorrect",
    "10136_4": "The second question is invalid",
    "10136_5": "Answer of the second question is incorrect",
    "10141_1": "Password is incorrect",
    "10141_2": "Password hint is invalid",
    "10146_1": "Type is wrong",
    "10148_1": "Type is wrong",
    "10148_2": "Level is wrong",
    "10150_1": "Token is invalid",
    "10161_1": "Bio is invalid",
    "10165_1": "User_ID is invalid",
    "10165_2": "Reason is invalid",
    "10165_3": "Description is invalid",
    "10173_1": "status is invalid",
    "10177_1": "phone format is invalid",
    "10178_1": "Failed to read user representative",
    "10178_2": "Already Registered",
    "10178_3": "Error in update user",
    "10179_1": "Invalid offset",
    "10179_2": "Invalid limit",
    "10180_1": "Failed to read user activities",
    "10181_1": "Failed to read user score",
    "10182_1": "Invalid plan code",
    "10183_1": "Failed to read plan",
    "10183_2": "Plan not found",
    "10183_3": "Failed to read user's activity",
    "10183_4": "Failed to update user's score",
    "10183_5": "Failed to set activity",
    "10183_6": "Failed to rollback score",
  },
  global: {
    insert_location: "Enable location in your system settings.",
    not_found_location: "Your location could not be identified.",
    map: "Map",
    send_location: "Send location",
    connection_faild: "Waiting for network",
    video_call: "Video call",
    voice_call: "Voice call",
    go_to_roadmap: "See Develop Roadmap",
    coming_soon: "Coming Soon ...",
    beta: "Beta Version",
    drag_file_here: "Drag file here",
    send_original: "Send Original",
    crop_and_send: "Crop and Send",
    active: "Active",
    add: "Add",
    agree: "Agree",
    all: "All",
    are_you_sure: "Are you sure?",
    are_you_sure_delete_account: "Are you sure you want to delete your account ?",
    are_you_sure_delete_account_description: " if you delete your account, all sort of files received as messages will be deleted permanently!",
    block: "Block",
    bot: "Bot",
    call: "Calls",
    cancel: "Cancel",
    channel_info: "Channel Info",
    close: "Close",
    cloud: "Cloud",
    confirm: "Confirm",
    contact: "Contacts",
    copy: "Copy",
    copy_link: "Copy link",
    copyright: "Release date: {{year}} © all rights reserved",
    country: "Country",
    credit: "Credit",
    dark_mode: "Dark mode",
    date: "Date",
    delete: "Delete",
    delete_for_all: "Delete for all",
    delete_image: "Delete image",
    description: "Description",
    disagree: "Disagree",
    discovery: "iLand",
    download: "Download",
    edit: "Edit",
    first_name: "First Name",
    forward: "Forward",
    forward_to: "Forward to {{forwardCount}}",
    forwarded: "Forwarded from",
    group_info: "Group Info",
    inactive: "Inactive",
    invite: "Invite",
    invite_friends: "Invite Friends",
    last_name: "Last Name",
    members: "Members",
    mobile: "Mobile",
    month: "Month",
    nearby: "Nearby",
    no: "No",
    online: "Online",
    password: "Password",
    pin: "Pin",
    please_wait: "Please wait",
    profile: "Profile",
    qrcode_scan: "QR code scan",
    rank: "Rank",
    reason: "Reason",
    recovery_email: "Recovery email",
    remove: "Remove",
    replied: "Replied to",
    reply: "Reply",
    report: "Report",
    return_to_igap: "Return to igap",
    riyal: "Riyals",
    score: "Score",
    from: "From",
    ivand_rank: "From {{val}}",
    ivand_title: "Scores : ",
    ivand_history: "score history",
    point: "Point",
    your_point: "Your score",
    upgrade_point: "Increase your score right now!",
    search: "Search",
    search_member: "Search members...",
    select: "Select",
    search_not_found: "No results found!",
    selected_item: "{{number}} item is selected.",
    send: "Send",
    settings: "Settings",
    submit: "Submit",
    time: "Time",
    title: "iGap",
    toman: "Toman",
    unblock: "Unblock",
    unpin: "Unpin",
    update_check: "Check update",
    user_info: "User Info",
    version: "Version",
    welcome: "Welcome to iGap {{platform}} version",
    yes: "Yes",
    wait: "Please Wait",
    next: "Next Step",
    room_info: "Room info",
    popup_buy_sticker: "Buy Virtual Gift",
    popup_gift_card_detail: "gift card Detail",
    popup_digital_gift_card_information: "Digital gift card information",
    popup_digital_gift_card_information_save_to_clipboard: "Save To ClipBoard",
    popup_digital_gift_card_credit_card_number: "Credit card number",
    popup_digital_gift_card_expiration_date: "Expiration date",
    popup_digital_gift_card_cvv2: "CVV2",
    popup_digital_gift_card_second_internet_password: "second internet password",
    nationalCode: "National Code",
    enable: "Enable",
    favourite_channels: "Favourite Channels",
    popup_inquiry_mci: "Inquiry Mci",
    popup_inquiry_telecom: "Inquiry Telecom",
    phone_number: "Phone Number",
    prefix: "Prefix",
    pause: "Pause",
    continue: "Continue",
    go_to_message: "Go To Message",
    discovery_news: "News",
    room_not_found: "No Room Found With This Link !",
    something_wrong: "something went wrong , please try again",
    success_message: "Success !",
    unread_messages: "Unread Messages",
    accept: "Accept",
    check_update: "Check Update",
    no_update_available: "You're already using latest version",
    retry: "Retry",
    get_ready_file: "getting ready file...",
    person: "person",
    motions: "Motions",
    static: "Static",
    gif: "Gif",
    all_sticker: "All",
    number_file_attachment: "{{attachment_number}} file ready for send",
    check_NetWorkConnection: "Connection has Failed , please Try Again",
    today: "Today",
    yesterday: "Yesterday",
  },
  error_boundary: {
    title: "iGap has crashed !",
    desc: "An unexpected error occurred forcing the application to stop We are aware of this error . Please be sure we are fixing this problem , all you have to do is only click Reset .",
    reset: "Reset",
  },
  multi_tab: {
    title: "Error! Too many tabs found",
    desc: "iGap supports only one active tab with the same browser. Please reload this page to continue using or close it and use another open tab.",
    cta: "reload",
  },
  destruction: {
    destruction: "تخریب",
    description: "شما اکنون در حال تلاش برای تخریب اکانت خود هستید، شماره تلفن شما برابر است با :",
    destruction_code: "ِDestruction code",
    enter_code: "Please enter code",
  },
  info_log: {
    [RoomMessageLog.Type.USER_JOINED]: "{{authorName}} joined iGap",
    [RoomMessageLog.Type.USER_DELETED]: "{{authorName}} left iGap",
    [RoomMessageLog.Type.ROOM_CREATED]: "{{authorName}} Created {{roomType}}",
    [RoomMessageLog.Type.MEMBER_ADDED]: "{{authorName}} added {{targetName}} to {{roomType}}",
    [RoomMessageLog.Type.MEMBER_KICKED]: "{{authorName}} kicked {{targetName}} from {{roomType}}",
    [RoomMessageLog.Type.MEMBER_LEFT]: "{{authorName}} left the {{roomType}}",
    [RoomMessageLog.Type.ROOM_CONVERTED_TO_PUBLIC]: "{{roomType}} converted to Public",
    [RoomMessageLog.Type.ROOM_CONVERTED_TO_PRIVATE]: "{{roomType}} converted to Private",
    [RoomMessageLog.Type.MEMBER_JOINED_BY_INVITE_LINK]: "{{targetName}} joined to {{roomType}} via Invite Link",
    [RoomMessageLog.Type.ROOM_DELETED]: "{{authorName}} deleted {{roomType}}",
    [RoomMessageLog.Type.MISSED_VOICE_CALL]: "Missed voice call",
    [RoomMessageLog.Type.MISSED_VIDEO_CALL]: "Missed video call",
    [RoomMessageLog.Type.MISSED_SCREEN_SHARE]: "Missed screen share",
    [RoomMessageLog.Type.MISSED_SECRET_CHAT]: "Missed secret chat",
    [RoomMessageLog.Type.PINNED_MESSAGE]: "Message pinned: {{pinnedMessage}}",
    [RoomMessageLog.Type.CHANGE_PHONE_NUMBER]: "{{authorName}} changed phone number",
  },
  lang: {
    [LocalesType.AR]: "عربى",
    [LocalesType.EN]: "English",
    [LocalesType.FA]: "فارسی",
    title: "Language",
  },
  news: {
    news_detail: {
      share_news: "اشتراک گذاری خبر",
      your_opinion: "نظر شما چیست ؟",
      no_comments: "هیچ نظری ثبت نشده است.",
      comments: "نظرات",
      new_comment_title: "Add comment",
      new_comment_name: "Name",
      new_comment_email: "Email",
      new_comment_comment: "Your comment",
      new_comment_send: "Send",
      new_author_error: "name is a required field",
      new_comment_error: "comment is a required field",
      new_email_error: "email is required field",
    },
  },
  login: {
    active_code: "Active Code",
    answer_security_question: "Answer Security Question",
    email: "Email",
    forgot_password: "Forgot password",
    hint: "Hint",
    login: "Login",
    login_by_mobile: "Login by mobile",
    login_by_qrcode: "Login by QR code",
    logout: "Logout",
    delete_account: "Delete account",
    phone_confirm_question: "Do you confirm your phone?",
    phone_confirm_title: "Confirm phone number",
    phone_edit: "Edit phone number",
    resend: "Resend code",
    rules_accept: "By registering in iGap you will accept the <1>rules\u00a0and\u00a0regulations</1>",
    rules_title: "Terms and Conditions",
    security_question: "Security Question",
    send_code: "Send code",
    back_to_account: "Back to iGap",
    back_to_login: "back",
    resend_recovery_email: "Resend the email",
  },
  message_types: {
    undefined: "message",
    [RoomMessageType.TEXT]: "Text file",
    [RoomMessageType.IMAGE]: "Image file",
    [RoomMessageType.IMAGE_TEXT]: "Image file",
    [RoomMessageType.VIDEO]: "Video file",
    [RoomMessageType.VIDEO_TEXT]: "Video file",
    [RoomMessageType.AUDIO]: "Audio file",
    [RoomMessageType.AUDIO_TEXT]: "Audio file",
    [RoomMessageType.VOICE]: "Voice file",
    [RoomMessageType.GIF]: "Gif file",
    [RoomMessageType.GIF_TEXT]: "Gif file",
    [RoomMessageType.FILE]: "File",
    [RoomMessageType.FILE_TEXT]: "File",
    [RoomMessageType.LOCATION]: "Map location",
    [RoomMessageType.LOG]: "Notification",
    [RoomMessageType.CONTACT]: "Contact",
    [RoomMessageType.WALLET]: "Transaction",
    [RoomMessageType.STICKER]: "Sticker",
    [RoomMessageType.STORY_REPLY]: "Moment",
  },
  messenger_editor: {
    compose_text: "Broadcast",
  },
  platforms: {
    [Platform.UNKNOWN_PLATFORM]: "Unknown platform",
    [Platform.ANDROID]: "Android",
    [Platform.IOS]: "Ios",
    [Platform.MAC_OS]: "MacOS",
    [Platform.WINDOWS]: "Windows",
    [Platform.LINUX]: "Linux",
    [Platform.BLACK_BERRY]: "BlackBerry",
  },
  my_bills: {
    title: "My bills",
    phone_number: "phone_number",
    mobile_number: "mobile_number",
    total_due_last_term: "Total due last term",
    total_due_mid_term: "Total due mid term",
    pay_last_term: "Pay last term",
    pay_mid_term: "Pay mid term",
    pay: "Pay",
    detail: "Detail",
    bill_id: "Bill id",
    bill_pay_id: "Bill pay id",
    time_limit: "Time limit",
    total_due: "Total due",
    branch_info: "Branch info",
    add_bills_list: "Add to my bill's list",
    show_bills_image: "Show bill's image",
    edit_bills: "Edit bill",
    bill_info: "Bill info",
    bill_detail: "Bill details",
    bill: "Bill",
  },
  bill_payment: {
    bill_title: "Bill inquiry and quick payment",
    bill_type: "Bill type0",
    my_bill: "Inquiry my bill",
    my_electricity_bills: "Check Bills",
    service_bills: "Service bills",
    phone_bills: "Phone bills",
    phone_title: "Please enter your phone number or mobile number",
    bills_name: "Bill's name",
    save_changes: "Save changes",
    bill: {
      ELECTRICITY: "Bill id",
      MOBILE_MCI: "Mobile number",
      PHONE: "Phone number",
      GAS: "Subscription number",
    },
  },
  igasht: {
    title: "IGasht",
    choose_city: "Select the city you want",
    search_entertainment: "Search entertainment centers",
    location_title: "Recreational areas of {{city}} province",
    founded_location: "{{count}} items found",
    select_location: "Select location",
    entertainment: "Entertainment places",
    purchase_code: "Your purchase code {{code}}",
    purchase_message: "Scan the barcode above to enter and visit",
    purchase_successful: "Your payment has been successful",
    buy_ticket: {
      finall_credit: "Total price: {{price}} Rials",
      service: "Service",
      count: "Count",
      price: "Price",
      buy_tickets: "Buy tickets",
      detail: "Details",
    },
  },
  infoAlert: "This action provided for other(android/ios) iGap clients.",
  charge_popup: {
    title: "Top up SIM card",
    buy_charge: "Buying the charge",
    choose_contact: "From contacts",
    choose_operator: "Operator selection",
    info: "if you have transferred, select your new operator",
    previous_purchases: "Previous purchases",
    amount: "Amount",
    discount_plans: "Discount plans",
    discount_code: "Discount code",
    discount: "discount",
    rials: "Rials",
    enter_discount_code: "Enter your discount code",
    save_code: "Save code",
    pay: "Pay",
    cancel: "Cancel",
    your_score: "Your score",
    spending_score: "Spending score",
  },
  privacy_popup: {
    account_self_destructs: "Account self-destructs",
    active_sessions: "Active Sessions",
    active_sessions_popup: {
      build_version: "Build Version",
      current_session: "Current Session",
      sessions: "All Sessions",
      terminate: "Terminate",
    },
    after: "after",
    allowed_video_call: "Who can video call me?",
    allowed_voice_call: "Who can call me?",
    blocked_list: "Blocked List",
    blocked_List_popup: {
      no_blocked_account: "no account found",
      unblock: "Unblock",
    },
    everybody: "Everybody",
    invite_to_channel: "Who can invite me to Channels?",
    invite_to_group: "Who can invite me to Groups?",
    last_seen: "Last Seen",
    my_contacts: "My Contacts",
    nobody: "Nobody",
    privacy: "Privacy",
    security: "Security",
    self_destructs_text: "account will be destructs after this time",
    two_step: {
      assign_password: "Assign Password",
      change_hint: "Change hint",
      change_recovery_email: "Change recovery email",
      change_recovery_questions: "Change recovery questions",
      delete_two_step: "Delete two step",
      repeat_password: "Repeat Password",
      start_text: "some text about two step verification",
      verify_recovery_email: "Verify recovery email",
      email_already_confirmed: "This email is already your Recovery email",
    },
    two_step_verification: "Two-Step Verification",
    view_profile: "Who can see my Avatars?",
  },
  contact_popup: {
    title: "Add New Contact",
    edit_contact: "Edit Contact",
  },
  coming_soon: "Coming Soon",
  profile_popup: {
    add_account: "Add new Account",
    bio: {
      bio: "Bio",
    },
    display_name: "Name",
    edit_profile: "Edit Profile",
    email: "Email",
    gender: {
      female: "Female",
      gender: "Gender",
      male: "Male",
    },
    phone: {
      phone: "Phone",
      invalid_phone: "invalid phone",
      new_phone_identify: "identify new phone",
      sent_code: "sent code",
      invalid_code: "invalid code",
      change_new_phone_successfully: "change new phone successfully",
    },
    representative: "Representative",
    username: {
      available: "Available",
      invalid: "Invalid",
      taken: "Taken",
      username: "Username",
    },
    failedReq: "Could not get {{inputName}} from server",
  },
  room_types: {
    undefined: "Chat",
    [Room.Type.CHAT]: "Chat",
    [Room.Type.GROUP]: "Group",
    [Room.Type.CHANNEL]: "Channel",
  },
  sticker_add_popup: "Add Sticker",
  room_info_popup: {
    add_member: "Add New Members",
    admin_rights: {
      add_admin: "Add Admin",
      admin_rights: "Admin Rights",
      delete_member: "Delete Member",
      post_message: "Post Message",
      edit_message: "Edit Message",
      delete_message: "Delete Message",
      modify_room: "Modify RoomShowcase",
      remove_admin: "Remove Admin",
      sign_messages: "Sign Messages",
      reaction_channel: "Reaction in Channel",
      add_Story: "Add Story",
      delete_Story: "Delete Story",
      show_Story_Views: "Show Story Views",
    },
    assign_admin: "Assign Admin",
    change_owner: "Transfer $t(room_types.{{room}}) Ownership",
    are_you_sure_change_owner: "Are you sure you want to change the ownership of this $t(room_types.{{room}}) to {{user}}?",
    edit: {
      description: "Description",
      edit_channel: "Edit Channel",
      edit_group: "Edit Group",
      name: "Name",
      room_type: "Room Type",
    },
    edit_admin: "Edit Admin Rights",
    leave_channel: "Leave Channel",
    join_channel: "Join Channel",
    join_group: "Join Group",
    leave_group: "Delete and Leave Group",
    block_confirm_message: "Are you sure to block this User?",
    unblock_confirm_message: "Are you sure to unblock this User?",
    clear_history_message: "Are you sure you want to clear this chat history?",
    member_list: "Show Members List",
    mute_notification: "Mute Notification",
    convertToGroup: "Convert To Group",
    permission: {
      add_new_members: "Add New Members",
      group_rights: "Group's Rights",
      member_rights: "Member Rights",
      pin_message: "Pin Message",
      send_gif: "Send Gif",
      send_link: "Send Link",
      send_media: "Send Media",
      send_sticker: "Send Sticker",
      send_text: "Send Text",
      show_member_list: "Show Member List",
    },
    remove_user: "Remove User",
    report: "Report",
    shared_audio: "Shared Audios",
    shared_file: "Shared Files",
    shared_gif: "Shared Gifs",
    shared_image: "Shared Images",
    shared_media: "Shared Media",
    shared_url: "Shared Links",
    shared_video: "Shared Videos",
    shared_voice: "Shared Voices",
  },
  report_reason: {
    [ClientRoomReport.Reason.OTHER]: "Abuse",
    [ClientRoomReport.Reason.SPAM]: "Other",
    [ClientRoomReport.Reason.PORNOGRAPHY]: "Pornography",
    [ClientRoomReport.Reason.VIOLENCE]: "Spam",
    [ClientRoomReport.Reason.ABUSE]: "Violence",
  },
  setting: {
    chat_setting: "Chat Settings",
    data_and_storage: "Data And Storage",
    notification: "Notifications",
    profile: "Profile",
    security_and_privacy: "Setting And Privacy",
    logout_message: "Are you sure you want to sign out of your iGap account?",
  },
  story: {
    deleted: "Deleted",
    story: "Moments",
    expired: "ٍExpired",
    my_moment: "My moment",
    tap_to_add_moment: "Tap to add moment",
    recent_updates: "Recent Updates",
    hint: "moments will be delete after 24 hours",
    delete_text: "this moment will delete for everyone see this !",
    story_view: "{{storyCount}} views",
    story_viewed_by: " Viewed by {{storyCount}}",
    sending_message: "Sending Message...",
    message_sent: "Message sent successfully !",
    reply: "Reply",
    no_content_title: "Share your moments !!",
    no_content_desc: "In order to see your friends' moments or to share your moments with your friends, you must have a mobile phone.",
    no_content_button: "Download Mobile Version !",
  },
  tabs: {
    [asideTabs.CONTACT]: "Contacts",
    [asideTabs.CALL]: "Calls",
    [asideTabs.CHAT]: "Chats",
    [asideTabs.ILAND]: "iLand",
    [asideTabs.SETTING]: "Profile",
    [asideTabs.STORY]: "Moments",
  },
  invite_friends: "Hey Join iGap : https://www.igap.net I'm waiting for you!",
  validate: {
    accepted: "The field must be accepted.",
    active_url: "The field is not a valid URL.",
    after: "The field must be a date after {{date}}.",
    after_or_equal: "The field must be a date after or equal to {{date}}.",
    alpha: "The field may only contain letters.",
    alpha_dash: "The field may only contain letters, numbers, dashes and underscores.",
    alpha_num: "The field may only contain letters and numbers.",
    array: "The field must be an array.",
    before: "The field must be a date before {{date}}.",
    before_or_equal: "The field must be a date before or equal to {{date}}.",
    between: {
      array: "The field must have between {{min}} and {{max}} items.",
      file: "The field must be between {{min}} and {{max}} kilobytes.",
      numeric: "The field must be between {{min}} and {{max}}.",
      string: "The field must be between {{min}} and {{max}} characters.",
    },
    boolean: "The field field must be true or false.",
    confirmed: "The field confirmation does not match.",
    date: "The field is not a valid date.",
    date_equals: "The field must be a date equal to {{date}}.",
    date_format: "The field does not match the format {{format}}.",
    different: "The field and {{other}} must be different.",
    digits: "The field must be {{digits}} digits.",
    digits_between: "The field must be between {{min}} and {{max}} digits.",
    dimensions: "The field has invalid image dimensions.",
    distinct: "The field field has a duplicate value.",
    email: "The field must be a valid email address.",
    ends_with: "The field must end with one of the following: {{values}}.",
    exists: "The selected field is invalid.",
    file: "The field must be a file.",
    filled: "The field field must have a value.",
    gt: {
      array: "The field must have more than {{value}} items.",
      file: "The field must be greater than {{value}} kilobytes.",
      numeric: "The field must be greater than {{value}}.",
      string: "The field must be greater than {{value}} characters.",
    },
    gte: {
      array: "The field must have {{value}} items or more.",
      file: "The field must be greater than or equal {{value}} kilobytes.",
      numeric: "The field must be greater than or equal {{value}}.",
      string: "The field must be greater than or equal {{value}} characters.",
    },
    image: "The field must be an image.",
    in: "The selected field is invalid.",
    in_array: "The field field does not exist in {{other}}.",
    integer: "The field must be an integer.",
    ip: "The field must be a valid IP address.",
    ipv4: "The field must be a valid IPv4 address.",
    ipv6: "The field must be a valid IPv6 address.",
    json: "The field must be a valid JSON string.",
    length: {
      min: "The field at least must contain {{min}} characters.",
    },
    lt: {
      array: "The field must have less than {{value}} items.",
      file: "The field must be less than {{value}} kilobytes.",
      numeric: "The field must be less than {{value}}.",
      string: "The field must be less than {{value}} characters.",
    },
    lte: {
      array: "The field must not have more than {{value}} items.",
      file: "The field must be less than or equal {{value}} kilobytes.",
      numeric: "The field must be less than or equal {{value}}.",
      string: "The field must be less than or equal {{value}} characters.",
    },
    max: {
      array: "The field may not have more than {{max}} items.",
      file: "The field may not be greater than {{max}} kilobytes.",
      numeric: "The field may not be greater than {{max}}.",
      string: "The field may not be greater than {{max}} characters.",
    },
    mimes: "The field must be a file of type: {{values}}.",
    mimetypes: "The field must be a file of type: {{values}}.",
    min: {
      array: "The field must have at least {{min}} items.",
      file: "The field must be at least {{min}} kilobytes.",
      numeric: "The field must be at least {{min}}.",
      string: "The field must be at least {{min}} characters.",
    },
    not_in: "The selected field is invalid.",
    not_regex: "The field format is invalid.",
    numeric: "The field must be a number.",
    password: "The password is incorrect.",
    passwordConfirmation: "Password and Password Confirmation must match.",
    phone: "The field must be a valid phone number.",
    present: "The field field must be present.",
    regex: "The field format is invalid.",
    required: "The field {{field}} is required.",
    required_if: "The field field is required when {{other}} is {{value}}.",
    required_unless: "The field field is required unless {{other}} is in {{values}}.",
    required_with: "The field field is required when {{values}} is present.",
    required_with_all: "The field field is required when {{values}} are present.",
    required_without: "The field field is required when {{values}} is not present.",
    required_without_all: "The field field is required when none of {{values}} are present.",
    same: "The field and {{other}} must match.",
    size: {
      array: "The field must contain {{size}} items.",
      file: "The field must be {{size}} kilobytes.",
      numeric: "The field must be {{size}}.",
      string: "The field must be {{size}} characters.",
    },
    starts_with: "The field must start with one of the following: {{values}}.",
    string: "The field must be a string.",
    timezone: "The field must be a valid zone.",
    unique: "The field has already been taken.",
    uploaded: "The field failed to upload.",
    url: "The field format is invalid.",
    uuid: "The field must be a valid UUID.",
  },
  wallet: {
    bill_id: "Bill id",
    bill_type: "Bill type",
    card_number: "Card Number",
    card_owner: "Card Owner",
    cardToCardInvoiceNumber: "Billing number",
    charger_mobile_number: "Receiver\\'s mobile number",
    description: "Description",
    destination_bank: "Destination Bank",
    destination_card: "Destination Card",
    pec_qr: "Wallet",
    header: {
      [RoomMessageWallet.Type.MONEY_TRANSFER]: "Money transfer",
      [RoomMessageWallet.Type.PAYMENT]: "Payment",
      [RoomMessageWallet.Type.CARD_TO_CARD]: "Card to Card",
      [RoomMessageWallet.Type.TOPUP]: "Topup",
      [RoomMessageWallet.Type.BILL]: "Bill",
    },
    order_id: "Order id",
    pay_id: "Pay id",
    requester_mobile_number: "Requester mobile number",
    rrn: "Reference No",
    source_bank: "Source bank",
    source_card: "Source Card",
    terminal_No: "Terminal no",
    topup_type: "Topup type",
    topup_types: {
      [RoomMessageWallet.Topup.Type.IRANCELL_PREPAID]: "Irancell Prepaid",
      [RoomMessageWallet.Topup.Type.IRANCELL_WOW]: "Irancell WOW",
      [RoomMessageWallet.Topup.Type.IRANCELL_WIMAX]: "Irancell Wimax",
      [RoomMessageWallet.Topup.Type.IRANCELL_POSTPAID]: "Irancell Postpaid",
      [RoomMessageWallet.Topup.Type.MCI]: "Mci",
      [RoomMessageWallet.Topup.Type.RIGHTEL]: "Rightel",
    },
    trace_number: "Trace number",
    wallet_amount: "Amount",
    wallet_from: "From",
    wallet_to: "To",
    wallet_amount_label: "Please enter the amount",
    wallet_qrCode_label: "Please enter the QR code",
  },
  welcome_futures: {
    "1": {
      content:
        "iGap attaches the utmost importance to your security and privacy using the individual encryption algorithms and guarantees a safe and secure connection between you, your friends and family.",
      title: "Security & privacy",
    },
    "2": {
      content: "iLand! without limitation with wonderful events as taking a taxi, pay bills and booking hotels and flights . Oh Also you can play games, watch films and listen to music",
      title: "iLand",
    },
    "3": {
      content: "Leave a new world around me. Around you, find your friends, entertainment centers, art, business and other and enjoy your moments ...",
      title: "Nearby Feature",
    },
    "4": {
      content: "You can have one-on-one or group chats and even create your own channel and add members in order to share information with millions of people.",
      title: "Chat",
    },
  },
  search: {
    chats: "Chats",
    contacts: "Contacts",
    channels: "Channels",
    messages: "Messages",
    groups: "Groups",
    titles: {
      mine: "Chats and Contacts",
      global: "Global search",
    },
  },
  notification_popup: {
    title_alert: "Notification",
    sound: "Sound",
    preview: "Message Preview",
    disable: "Turn Off Notification",
    default_message: "There is a New Message",
  },
  update_popup: {
    title: "Update",
    new_version_available: "Update is Available , Do You Want To Update ?",
    yes: "Yes",
    no: "Not Now",
  },
  username_popup: {
    title: "Change Username",
    field: "New Username :",
  },
  convertToGroup_popup: {
    title: "Convert To Group",
    name: "Group Name",
    description: "Group Description",
    accept: "Creat",
  },
  roadmap: {
    title: "Last Update : {{date}}",
    button: "Go To New Web Version",
    [RoadmapDataType.TODO]: "Features Will be implement",
    [RoadmapDataType.DOING]: "Features Are Working on it",
    [RoadmapDataType.DONE]: "Implemented Features !",
  },
  popup_receipt: {
    title: "Receipt",
    final: "Final Price : ",
    coupon_notvalid: "Coupon is not valid",
    discount: "Discount :  ",
    score_spent: "Score Spent : ",
  },
  popup_gift_sticker: {
    info: "You're sending gift sticker",
    title: "Buy GiftCard",
    submit_button: "Purchase",
    my_cards: "my gift cards",
    cards_NEW: "new gift cards",
    cards_FORWARDED: "forwarded gift cards",
    cards_ACTIVE: "activated gift cards",
    activated_cards: "activated gift cards",
    status_PENDING: "pending...",
    status_SUCCESS: "Success !",
    status_WRONG: "your national code isn't valid",
    status_ERROR: "something went wrong ! please check your detail and try again",
    final_success: "Gift Card Enabled Successfully ; now you can manage your cards in iLand !",
    final_error: "Something went wrong , please try again",
  },
  popup_a2HS: {
    title: "Add IGap application",
    share_button: "1- Click the share button in the bottom bar",
    add_2hs: "2- Select the Add to Home Screen option",
    add_hs: "3- Click on Add at the top",
    add: "Add",
    close: "close",
  },
  popup_buy_data: {
    title: "buy internet packages",
    special_packages: "Special Packages",
    nonSpecial_packages: "all Packages",
    list_titles: {
      [internetPackageEnum.Credit]: "Credit Packages",
      [internetPackageEnum.Permanent]: "Permanent Packages",
      [internetPackageEnum.CreditPermanent]: "credit and permanent Packages",
      [internetPackageEnum.CreditTdLte]: "Credit TD_LTE Packages",
      [internetPackageEnum.Permanent_Td_Lte]: "PERMANENT TD_LTE Packages",
      [internetPackageEnum.Data]: "Data Packages",
    },
    package_type: {
      [internetPackageTypes.Time]: "Time",
      [internetPackageTypes.Volume]: "Volume",
    },
  },
  popup_financial_history: {
    title: "Financial History",
    order_id: "Order Id : ",
    success_payment: "Success",
    failure_payment: "Failure",
    fields: {
      billId: "billId",
      billtype: "billtype",
      cardnumber: "cardnumber",
      merchantname: "merchantname",
      payid: "payid",
      amount: "amount",
      orderid: "orderid",
      rrn: "rrn",
      terminalno: "terminalno",
      traceno: "traceno",
      bankname: "bankname",
      cardownername: "cardownername",
      destbankname: "destbankname",
      destcardnumber: "destcardnumber",
      sourcecardnumber: "sourcecardnumber",
    },
    transaction_type: {
      [MplTransaction.Type.BILL]: "Bills",
      [MplTransaction.Type.CARD_TO_CARD]: "card to card",
      [MplTransaction.Type.NONE]: "All",
      [MplTransaction.Type.SALES]: "Sales",
      [MplTransaction.Type.TOPUP]: "Topup",
    },
  },
  popup_inquiry: {
    prefix_example: "example : 021",
    phone_example: "example : 44567899",
    error_number: "Wrong Number !",
    last_term: "Last Term",
    mid_term: "MidTerm",
    billId: "Bill Id",
    payId: "Pay Id",
    amount: "Amount (Riyal)",
  },
};

export default en;
